import React, { JSX, useEffect, useState } from 'react';
import { viewport } from '../../utils/utils';
import Styles from './IndividualLineCheck.module.scss';
export const IndividualLineCheck = React.forwardRef<HTMLInputElement, any>(
  (
    {
      parentCallBackIndividual,
      content,
      apiError,
      setApiError,
      setFetchingLineCheck,
      setSelectedAddress,
      FetchingLineCheck,
      addressRef,
      openIndividualLineCheck,
      selected,
      addressNotFound,
      setaddressNotFound,
      isAddressNotFilled,
      setAddressNotFilled,
      setIndivialOpen
    },
    ref: any
  ): JSX.Element => {
    const [addressData, setAddressData] = useState({
      street: '',
      city: '',
      postCode: '',
      houseNumber: '',
      concatedAddress: ''
    });
    const [concatedAddressState, setConcatedAddressState] = useState<string>('');
    const viewPort = viewport();
    const [clicked, setClicked] = useState<boolean>(false);
    useEffect(() => {
      typeof setApiError === 'function' && setApiError(false);
      typeof setFetchingLineCheck === 'function' && setFetchingLineCheck(false);
      typeof setSelectedAddress === 'function' && setSelectedAddress('');
    }, []);
    const handleChange = (e: any) => {
      setaddressNotFound(true);
      setAddressData({ ...addressData, [e.target.name]: e.target.value });
      const tempAddress = { ...addressData, [e.target.name]: e.target.value };
      updateConcatenatedAddress({ ...tempAddress });
      setApiError(false);
      setFetchingLineCheck(false);
      setIndivialOpen((prevState: any) => ({
        ...prevState,
        indErrorOpen: false
      }));
      // setClicked(false);
    };
    useEffect(() => {
      setAddressData(selected);
    }, [addressNotFound]);
    const updateConcatenatedAddress = (data: any) => {
      let concatedAddress = '';
      if (
        data?.postCode !== '' &&
        data.city !== '' &&
        data.houseNumber !== '' &&
        data.street !== ''
      ) {
        concatedAddress =
          data.street + ' ' + data.houseNumber + ',' + ' ' + data.postCode + ' ' + data.city;
        setConcatedAddressState(concatedAddress);
      } else {
        concatedAddress = '';
        setConcatedAddressState('');
      }
    };
    useEffect(() => {
      const tempAddress = {
        ...addressData,
        concatedAddress: concatedAddressState
      };
      setAddressData({ ...addressData, concatedAddress: concatedAddressState });
      if (viewPort !== 'mobile') {
        parentCallBackIndividual(tempAddress, clicked);
      }
    }, [concatedAddressState]);  
    const errorData = () => {
      return (
        <p className={Styles['error-section']}>
          <img src={'/ecom-int/icons/error-msg-icon.svg'} height={14} width={14} alt='error' />
          {content?.requiredFieldText}
        </p>
      );
    };

    const handleMobileButton = () => {
      setClicked(true);
      if (
        addressData?.postCode !== '' &&
        addressData?.city !== '' &&
        addressData?.houseNumber !== '' &&
        addressData?.street !== ''
      ) {
        typeof parentCallBackIndividual === 'function' &&
          parentCallBackIndividual(addressData, true);
      } else {
        typeof setAddressNotFilled === 'function' && setAddressNotFilled(!isAddressNotFilled);
      }
    };

    return (
      <div
        className={`${Styles['inputcontainer']} ${
          isAddressNotFilled && Styles['errorinput-container']
        }`}
      >
        <div
          className={`${
            isAddressNotFilled &&
            addressNotFound &&
            (addressData?.postCode === '' || addressData?.city === '') &&
            Styles['errorinput-small']
          } ${Styles['individuallinecheck']}`}
        >
          <div
            className={`${Styles['smallerinputcontainer']} form-floating ${
              isAddressNotFilled &&
              addressNotFound &&
              addressData?.postCode === '' &&
              Styles['errorinput-small-mobile']
            }`}
          >
            <input
              required
              placeholder={content?.zip + '*'}
              name='postCode'
              onChange={handleChange}
              value={
                !FetchingLineCheck && !addressNotFound ? selected?.postCode : addressData?.postCode
              }
              className={`form-control
                ${
                  (isAddressNotFilled || clicked) && addressNotFound && addressData?.postCode === ''
                    ? Styles['errorInputs']
                    : Styles['comman-css']
                } `}
            />
            <label htmlFor='address'>{content?.zip + '*'}</label>
            {(isAddressNotFilled || clicked) &&
              addressData?.postCode === '' &&
              addressNotFound &&
              errorData()}
          </div>
          <div
            className={`${Styles['cityinputcontainer']} form-floating ${
              isAddressNotFilled &&
              addressNotFound &&
              addressData?.city === '' &&
              Styles['errorinput-small-mobile']
            }`}
          >
            <input
              placeholder={content?.city + '*'}
              name='city'
              onChange={handleChange}
              value={!FetchingLineCheck && !addressNotFound ? selected?.city : addressData?.city}
              className={`form-control
                ${
                  (isAddressNotFilled || clicked) && addressNotFound && addressData?.city === ''
                    ? Styles['errorInputs']
                    : Styles['comman-css']
                }`}
            />
            <label htmlFor='address'>{content?.city + '*'}</label>
            {(isAddressNotFilled || clicked) &&
              addressData?.city === '' &&
              addressNotFound &&
              errorData()}
          </div>
        </div>
        <div className={`${Styles['individuallinecheck-bottom']}`}>
          <div
            className={`${Styles['cityinputcontainer']} form-floating ${
              isAddressNotFilled &&
              addressNotFound &&
              addressData?.street === '' &&
              Styles['errorinput-small-mobile']
            }`}
          >
            <input
              placeholder={content?.street + '*'}
              name='street'
              onChange={handleChange}
              value={
                !FetchingLineCheck && !addressNotFound ? selected?.street : addressData?.street
              }
              className={`form-control
                ${
                  (isAddressNotFilled || clicked) && addressNotFound && addressData?.street === ''
                    ? Styles['errorInputs']
                    : Styles['comman-css']
                }`}
            />
            <label htmlFor='address'>{content?.street + '*'}</label>
            {(isAddressNotFilled || clicked) &&
              addressData?.street === '' &&
              addressNotFound &&
              errorData()}
          </div>
          <div
            className={`${Styles['smallerinputcontainer']} form-floating ${
              isAddressNotFilled &&
              addressNotFound &&
              addressData?.houseNumber === '' &&
              Styles['errorinput-small-mobile']
            }`}
          >
            <input
              placeholder={content?.houseNumber + '*'}
              name='houseNumber'
              onChange={handleChange}
              value={
                !FetchingLineCheck && !addressNotFound
                  ? selected?.houseNumber
                  : addressData?.houseNumber
              }
              className={`form-control
                ${
                  (isAddressNotFilled || clicked) &&
                  addressNotFound &&
                  addressData?.houseNumber === ''
                    ? Styles['errorInputs']
                    : Styles['comman-css']
                }`}
            />
            <label htmlFor='address'>{content?.houseNumber + '*'}</label>
            {(isAddressNotFilled || clicked) &&
              addressData?.houseNumber === '' &&
              addressNotFound &&
              errorData()}
          </div>
        </div>
        {viewPort === 'mobile' && (
          <>
            <div className={Styles['individuallinecheck']}>
              <button
                name='check address button'
                type='button'
                className={`primarybutton ${Styles['btn']}`}
                disabled={false}
                onClick={handleMobileButton}
                style={{ width: '50%' }}
              >
                {content?.buttonvalue}
              </button>
            </div>
          </>
        )}
      </div>
    );
  }
);
